import { render, staticRenderFns } from "./WaitingDropdown.vue?vue&type=template&id=a6d52e60&scoped=true&lang=pug&"
import script from "./WaitingDropdown.vue?vue&type=script&lang=js&"
export * from "./WaitingDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WaitingDropdown.vue?vue&type=style&index=0&id=a6d52e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d52e60",
  null
  
)

/* custom blocks */
import block0 from "./WaitingDropdown.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VIcon,VMenu,VProgressLinear,VSpacer,VTab,VTabs})
